// A figure is shown with the precision its source gave it: 12.5 stays 12.5 (never 13), 45 stays 45, and a sum or
// a difference of such figures is rounded to that same precision (12.3 − 20 is −7.7, never −7.699999999999999).

// Decimal places in a number as it was sent (12.5 -> 1, 45 -> 0), at most 4.
export const decimalsOf = (n) => {
  if (typeof n !== "number" || !Number.isFinite(n)) return 0;
  const m = /\.(\d+)$/.exec(String(n));
  return m ? Math.min(m[1].length, 4) : 0;
};

// x as text, to dp places ("87.5", "40").
export const toPlaces = (x, dp = 0) => Number(x).toFixed(dp > 0 ? dp : 0);

// x rounded to dp places, as a number (for differences that are then compared or signed).
export const roundTo = (x, dp = 0) => Number(toPlaces(x, dp)) + 0;
